import { instagramFiltersInitialState } from './initialState/instagramInitialState';
import { multiPlatformFiltersInitialState } from './initialState/multiPlatformInitialState';
import { nativePlatformFiltersInitialState } from './initialState/nativePlatformsContentInitialState';
import { newsFiltersInitialState } from './initialState/newsInitialState';
import { newspaperFiltersInitialState } from './initialState/newspaperInitialState';
import { telegramFiltersInitialState } from './initialState/telegramInitialState';
import { twitterFiltersInitialState } from './initialState/twitterInitialState';
import { virastyFiltersInitialState } from './initialState/virastyInitialState';

export const dashboardInitialState = {
  dashboards: {
    data: [],
    loading: false,
    error: null,
  },
  currentDashboard: {
    data: [],
    loading: false,
    error: null,
  },
  contents: {},
  scrolledContents: {},
  newContents: {},
  dashboardId: -1,
  isStreamDrawerOpened: false,
  stream: {
    streamId: null,
    step: 0,
    type: 1,
    title: '',
    filterType: 1,
    params: {
      platforms: [],
    },
  },
  saveStreamRequest: {
    loading: false,
    error: null,
  },
  deleteStream: {
    loading: false,
    error: null,
  },
  filters: {
    instagram: instagramFiltersInitialState,
    news: newsFiltersInitialState,
    newspaper: newspaperFiltersInitialState,
    telegram: telegramFiltersInitialState,
    twitter: twitterFiltersInitialState,
    virasty: virastyFiltersInitialState,
    multiPlatform: multiPlatformFiltersInitialState,
    nativePlatforms: nativePlatformFiltersInitialState,
  },
  selectedFilter: undefined,
};
